// extracted by mini-css-extract-plugin
module.exports =  {"label":"_7a3fb80146--label--bSiVV","price":"_7a3fb80146--price--joswk","description":"_7a3fb80146--description--J94UV","link":"_7a3fb80146--link--dYkW6"};